import React from 'react';
import styled from 'styled-components';
import {
  HeadlineOne,
  HeadlineTwo,
  Paragraph,
  WrapperCenter,
} from 'components/atoms/SectionWrapper.style';

const EleFarmDesc = () => (
  <>
    <WrapperCenter>
      <HeadlineOne>OFERTA ELECTROMOBILITY:</HeadlineOne>
      <Paragraph>
        W Polsce ilość stacji ładowania samochodów elektrycznych w dalszym ciągu
        jest niewystarczająca. Użytkownicy „elektryków” planują trasy w oparciu
        o sprawne i dostępne stacje łądowania, z których w szybki i wygodny
        sposób mogą skorzystać. Analizując rynek widzimy, że w dalszym ciągu
        ilość nowych ogólnodostępnych punktów ładowania jest niewystarczająca
        dlatego też chcąc zmienić ten fakt rozpoczęliśmy współpracę z dwoma
        największymi polskimi producentami stacji ładowania EV: Do naszych
        partnerów należą Ekoenetrgetyka Polska i EVB Edward Biel.
      </Paragraph>
      <Paragraph>
        Nasza firma z powodzeniem realizuje się w branży elektromobilności od
        2019 roku. Dostarczamy Naszym klientom kompleksową usługę opierającą się
        na:
        <ul>
          <li>
            Analizie możliwości inwestycyjnych – weryfikacja lokalizacji pod
            kątem dostępnych mocy przyłączeniowych oraz potencjalnych zagrożeń i
            problemów mogących wpłynąć na realizację inwestycji{' '}
          </li>
          <br />
          <li>
            Przygotowanie rozwiązań dla danych lokalizacji – Na etapie
            przygotowania inwestycji dobieramy odpowiednie rozwiązania dla
            każdej nowej inwestycji w oparciu o wiedzę, doświadczenie a także
            dedykowane produkty takie jak Systemy sterowania energią obiektów,
            Systemy płatnicze, Systemy oraniczczania mocy ładowania i inne.{' '}
          </li>
          <br />

          <li>
            Projekt, uzgodnienia, dokumentacja – W oparciu o dobrane rozwiązania
            projektujemy całą inwestycję dzięki własnej kadrze inżynierów i
            projektantów. Dokonujemy wszelkich zgłoszeń, uzyskujemy warunki
            przyłączenia dla obiektów oraz pozwolenia na budowę. Kompleksowo
            podchodzimy do obsługi inwestycji zarówno przed jej rozpoczęciem, w
            trakcie jak i po realizacji przygotowując komplet dokumentacji
            powykonawczej.
          </li>
          <br />

          <li>
            Dostarczenie stacji wraz z instalacją, konfiguracją, uruchomieniem i
            obsługą serwisową – Dostarczamy rozwiązania dwóch polskich
            producentów stacji ładowania pojazdów elektrycznych. Jesteśmy
            autoryzowanym partnerem strategicznym EVB Edward Biel oraz
            Ekoenergetyka Polska. Dzięki doświadczonej kadrze pracowników oraz
            zapleczu realizacyjnemu prowadzimy cały proces od przygotowania
            miejsca instalacji ładowarek, konfigurację, uruchomienie oraz budowę
            infrastruktury towarzyszącej: znaki pionowe, poziome, separatory,
            odbojniki, fundamenty, malowanie miejsc postojowych.
          </li>
          <br />

          <li>
            Operator – Dla dostarczonych i zainstalowanych urządzeń dobieramy
            operatora spełniającego wszystkie oczekiwania inwestora. Ładowarki
            naszych partnerów są kompatybilne ze wszystkimi wiodącymi
            operatorami dla ładowarek EV w tym Elocity oraz Grennway.
          </li>
          <br />

          <li>
            UDT odbiory – Dla prawidłowego i komercyjnego użytkowania stacji
            ładowania wykonujemy pełną dokumentację potrzebną do udostępnienia
            ładowarek dla użytku komercyjnego. Zapewniamy kompletne odbiory UDT
            wraz z pomiarami.
          </li>
        </ul>
      </Paragraph>

      <Paragraph>
        Posiadamy kilka modeli współpracy a trzy główne z nich to:
        <ol>
          <li>
            Inwestycja we własną komercyjną stację lądowania – w tym modelu
            weryfikujemy dla inwestora lokalizacje, dobieramy rozwiązanie i
            realizujemy projekt w oparciu o przygotowany indywidualnie biznes
            plan, a inwestor zarabia na udostępnieniu możliwości ładowania i
            infrastrukturze towarzyszącej.
          </li>
          <br />

          <li>
            Udostępnienie miejsca pod budowę stacji ładowania – w tym modelu
            weryfikujemy posiadany przez właściciela grunt pod kątem budowy
            infrastruktury. Po uzyskaniu pozytywnej oceny lokalizacji tworzymy
            model biznesowy dla potrzeb inwestycyjnych i wraz z naszymi
            inwestorami stawiamy stację ładowania w ramach budowy własnej sieci
            puntów ładowania.
          </li>
          <br />

          <li>
            Wspólna inwestycja w budowę stacji ładowania - model ten zakłada
            realizację
          </li>
        </ol>
      </Paragraph>
      <Paragraph>
        Do kogo jest skierowana nasza oferta:
        <Paragraph>
          Strategiczne punkty na szlakach komunikacyjnych takie jak:
          <ul>
            <li>Hotele i Hostele</li>
            <li>Karczmy Restauracje</li>
            <li>Stacje Benzynowe i MOPy</li>
            <li>Parkingi</li>
          </ul>
          Strategiczne punkty w miastach:
          <ul>
            <li>Galerie,</li>
            <li>Obiekty użytku publicznego,</li>
            <li>Parkingi, Hotele, Hostele</li>
            <li>Sklepy wielkopowierzchniowe</li>
            <li>Firmy posiadające ogólnodostępne parkingi</li>
            <li>Salony samochodowe</li>
          </ul>
        </Paragraph>
      </Paragraph>

      <HeadlineTwo>
        Zapraszamy do kontaktu w celu poznania szczegółów naszej oferty
      </HeadlineTwo>
    </WrapperCenter>
  </>
);

export default EleFarmDesc;
